import {z} from 'zod';

import {REQUIRED_FIELD_MESSAGE} from '../../account/schemas/authSchemas';

export const competitionOptOutSchema = z.object({
  firstName: z
    .string({message: REQUIRED_FIELD_MESSAGE})
    .min(1, {message: REQUIRED_FIELD_MESSAGE})
    .transform(val => val.trim()),
  lastName: z
    .string({message: REQUIRED_FIELD_MESSAGE})
    .min(1, {message: REQUIRED_FIELD_MESSAGE})
    .transform(val => val.trim()),
  loyaltyNumber: z
    .string({message: REQUIRED_FIELD_MESSAGE})
    .min(1, {message: REQUIRED_FIELD_MESSAGE})
    .transform(val => val.trim()),
  email: z
    .string({message: REQUIRED_FIELD_MESSAGE})
    .min(1, {message: 'Email address is required'})
    .email({message: 'Please enter a valid email address'})
    .transform(val => val.trim()),
});

export type CompetitionOptOutFormData = z.infer<typeof competitionOptOutSchema>;
